import React from 'react';

// Styled Components
import {
  Container,
  ContainerFileIcon,
  ContainerInput,
  Text,
  SmallContainer,
  Thumbnail,
} from './styles';

// Types
import { InputProps } from './types';

// Icons
import LoadImageIcon from '../../../assets/icons/load-image-icon.svg';

export const ResumeLoadImages = ({
  imageData,
  ...props
}: InputProps): JSX.Element => {
  // Guard contra undefined: el loader del summary puede fallar offline y
  // propagar `images=undefined` hasta aquí (ver
  // docs/superpowers/plans/2026-05-12-offline-edit-action-accident.md § Fase 0).
  const items = imageData ?? [];
  return (
    <Container {...props}>
      {items.map((element, index) => {
        const isLastElement = index === items.length - 1;
        return (
          <ContainerInput lastElement={isLastElement} key={index}>
            <SmallContainer>
              {element.previewUrl ? (
                <Thumbnail src={element.previewUrl} alt={element.name} />
              ) : (
                <ContainerFileIcon src={LoadImageIcon} />
              )}
              <Text size="S" variant="medium">
                {element.name}
              </Text>
            </SmallContainer>
          </ContainerInput>
        );
      })}
    </Container>
  );
};
